export const newsletterContent = {
  nl: {
    seoTitle: 'Nieuwsbrief · Perpetual Plexus',
    seoDescription:
      'Schrijf je in voor de Perpetual Plexus nieuwsbrief en ontvang updates over nieuw werk, tentoonstellingen en projecten van Rot8ion.',
    title: 'Nieuwsbrief',
    intro: 'Blijf op de hoogte van nieuw werk, tentoonstellingen en projecten.',
    body: [
      'Af en toe stuur ik een update over wat er speelt rond Perpetual Plexus: nieuwe lichtsculpturen, samenwerkingen, tentoonstellingen of een kijkje achter de schermen.',
      'Je kunt je op elk moment weer uitschrijven via de link onderaan elke e-mail.',
    ],
  },
  en: {
    seoTitle: 'Newsletter · Perpetual Plexus',
    seoDescription:
      'Subscribe to the Perpetual Plexus newsletter for updates on new work, exhibitions, and projects by Rot8ion.',
    title: 'Newsletter',
    intro: 'Stay up to date on new work, exhibitions, and projects.',
    body: [
      'Every now and then I send an update on what is happening around Perpetual Plexus: new light sculptures, collaborations, exhibitions, or a behind-the-scenes look.',
      'You can unsubscribe at any time using the link at the bottom of every email.',
    ],
  },
} as const;
